const LOCAL_STORAGE_DATA = {
  ANSWERS: 'answers',
  EDUCATION: 'education',
  APPLICATION_ID: 'application_id',
} as const;

export default LOCAL_STORAGE_DATA;
